import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '@/features/auth/auth.store';
import type { Business } from '@/features/auth/types';
import { get } from '@/lib/api/client';

interface PagedBusinesses {
  results: Business[];
}

/** The stores the signed-in account is assigned to, sorted by name. */
export function useBusinesses() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated());

  return useQuery({
    queryKey: ['businesses', 'assigned'],
    queryFn: () => get<PagedBusinesses>('businesses/assigned'),
    enabled: isAuthenticated,
    staleTime: 5 * 60 * 1000,
    // This endpoint 401s for accounts with no assigned store, which is a valid
    // state, not a failure — retrying it just delays the empty list.
    retry: false,
    select: (data) =>
      [...(data.results ?? [])].sort((a, b) => a.name.localeCompare(b.name)),
  });
}
